// Utils
import { mergeArrayPropInto, mergeCountPropInto } from '../../../../common/utils/lib/mergeUtils';

export default (objValue, srcValue) => {
    if (!objValue) return srcValue;
    if (!srcValue) return objValue;

    let returnObject = {
        ...srcValue,
        ...objValue,
    };

    returnObject = mergeCountPropInto('changeCount', objValue, srcValue, returnObject);

    returnObject = mergeArrayPropInto('actorIds', objValue, srcValue, returnObject);
    returnObject = mergeArrayPropInto('elementIds', objValue, srcValue, returnObject);
    returnObject = mergeArrayPropInto('commentIds', objValue, srcValue, returnObject);

    return returnObject;
};
